module.exports = __webpack_public_path__ + "static/media/rilla.3e339aeb.png";